module.exports = __webpack_public_path__ + "static/polar-env1-6a6f2b1defa90d3ab7cc3b37bead5033.jpg";